import { gql } from '@apollo/client';

// 卸车明细列表（已卸子集，unloading_task_waypoint_id = 当前途经点）：结构与装车明细一致
export const GET_UNLOADED_INFO_LIST = gql`
    query GetUnloadedInfoList($taskId: Long!, $taskWaypointId: Long!) {
        getUnloadedInfoList(taskId: $taskId, taskWaypointId: $taskWaypointId) {
            barCode
            parcelQuantity
            isBag
            destinationSortingCode
        }
    }
`;

export interface UnloadedInfoType {
    barCode: string;
    parcelQuantity: number;
    isBag: boolean;
    destinationSortingCode?: string | null;
}

export interface GetUnloadedInfoListResponse {
    getUnloadedInfoList: UnloadedInfoType[];
}

export interface GetUnloadedInfoListVariables {
    taskId: number;
    taskWaypointId: number;
}
